import { render, staticRenderFns } from "./ExpedienteCreateTribunalView.vue?vue&type=template&id=00ddf47a&"
import script from "./ExpedienteCreateTribunalView.vue?vue&type=script&lang=js&"
export * from "./ExpedienteCreateTribunalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports